import { render, staticRenderFns } from "./WebpagesIndex.vue?vue&type=template&id=4df023a6&scoped=true&"
import script from "./WebpagesIndex.vue?vue&type=script&lang=js&"
export * from "./WebpagesIndex.vue?vue&type=script&lang=js&"
import style0 from "./WebpagesIndex.vue?vue&type=style&index=0&id=4df023a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df023a6",
  null
  
)

export default component.exports